import { ProductNotificationDto } from "@aihCustomBlueprint/Handlers/AihCustomProductSubscribe/AllNotificationProducts";
import ProductSubscribeState from "@aihCustomBlueprint/Store/Data/AihCustomProductSubscribe/ProductSubscribeState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductDto, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: ProductSubscribeState = {
    productStatusMulti: [],
    productStatus: [],
    subscribedProducts: null,
    notificationProducts: null,
    isLoading: false,
    failedToLoadInventory: false,
};

const reducer = {
    "Subscriptions/BeginLoad": (draft: Draft<ProductSubscribeState>) => {
        draft.isLoading = true;
    },
    "Subscriptions/DispatchCompleteLoadProductSubscriptionStatusMulti": (
        draft: Draft<ProductSubscribeState>,
        action: { productStatusMulti: ProductDto[] },
    ) => {
        draft.isLoading = false;
        draft.productStatusMulti = action.productStatusMulti;
    },
    "Notification/SetFailedToLoadInventory": (
        draft: Draft<ProductSubscribeState>,
        action: { parameter: { failedToLoadInventory: boolean } },
    ) => {
        draft.failedToLoadInventory = action.parameter.failedToLoadInventory;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
